import { POI, POIType } from '../models/POI'
import { gql } from 'graphql-request'
const pois: Array<POI> = [
  {
    name: 'Resto 1',
    type: 'restaurant',
    Location: [47.254749, 2.894922],
    contentItemId: '0'
  },
  {
    name: 'Resto 2',
    type: 'restaurant',
    Location: [47.116226, 2.92206],
    contentItemId: '1'
  },
  {
    name: 'A Faire 1',
    type: 'a-faire',
    Location: [47.212917, 3.461967],
    contentItemId: '2'
  },
  {
    name: 'A Voir 1',
    type: 'a-voir',
    Location: [47.182917, 3.461967],
    contentItemId: '3'
  },
  {
    name: 'Herbergement 1',
    type: 'hebergement',
    Location: [47.182917, 3.161967],
    contentItemId: '4'
  },
  {
    name: 'Produit Locaux 1',
    type: 'produit',
    Location: [47.212917, 3.361967],
    contentItemId: '5'
  },
  {
    name: 'Service 1',
    type: 'service',
    Location: [47.212917, 3.261967],
    contentItemId: '6'
  }
]

const generatePoiQuery = (type: POIType): string => {
  const GET_POI_FOODETABLISHMENT = gql`
    query GetFoodEtablishment {
      foodEstablishment(first: 5000) {
        contentItemId
        displayText
        starRating
        servesCuisine
        owner
        place {
          latitude
          longitude
          telephone
          streetAddress
          postalCode
          addressLocality
        }
        thing {
          description
          categories
          name
          alternateName
          image {
            urls
            paths
          }
          url {
            text
            url
          }
        }
      }
    }
  `

  const GET_POI_LODGINGBUSINESS = gql`
    query GetLodgingBusiness {
      lodgingBusiness(first: 5000) {
        contentItemId
        checkinTime
        checkoutTime
        displayText
        numberOfRooms
        place {
          latitude
          longitude
          telephone
          streetAddress
          postalCode
          addressLocality
        }
        thing {
          name
          alternateName
          categories
          description
          image {
            urls
            paths
          }
          url {
            text
            url
          }
        }
      }
    }
  `

  const GET_POI_SERVICE = gql`
    query GetService {
      service(first: 5000) {
        contentItemId
        displayText
        serviceType
        place {
          latitude
          longitude
          telephone
          streetAddress
          postalCode
          addressLocality
        }
        thing {
          name
          url {
            url
            text
          }
          image {
            urls
            paths
          }
          categories
          description
          alternateName
        }
      }
    }
  `

  const GET_POI_TOURISTATTRACTION = gql`
    query GetTouristAttraction {
      touristAttraction(first: 5000) {
        contentItemId
        displayText
        touristType
        place {
          latitude
          longitude
          telephone
          streetAddress
          postalCode
          addressLocality
        }
        thing {
          alternateName
          categories
          description
          image {
            paths
            urls
          }
          url {
            text
            url
          }
          name
        }
      }
    }
  `

  const GET_POI_TOURISTDESTINATION = gql`
    query GetTouristDestination {
      touristDestination(first: 5000) {
        contentItemId
        displayText
        touristType
        place {
          latitude
          longitude
          telephone
          streetAddress
          postalCode
          addressLocality
        }
        thing {
          alternateName
          categories
          description
          image {
            paths
            urls
          }
          name
          url {
            text
            url
          }
        }
      }
    }
  `

  const GET_POI_PRODUIT = gql`
    query GetProduit {
      product(first: 5000) {
        contentItemId
        place {
          latitude
          longitude
          telephone
          streetAddress
          postalCode
          addressLocality
        }
        displayText
        thing {
          alternateName
          categories
          description
          image {
            paths
            urls
          }
          name
          url {
            text
            url
          }
        }
      }
    }
  `

  switch (type) {
    case POIType.afaire:
      return GET_POI_TOURISTATTRACTION
    case POIType.avoir:
      return GET_POI_TOURISTDESTINATION
    case POIType.hebergement:
      return GET_POI_LODGINGBUSINESS
    case POIType.produit:
      return GET_POI_PRODUIT
    case POIType.restaurant:
      return GET_POI_FOODETABLISHMENT
    case POIType.service:
      return GET_POI_SERVICE
    default:
      break
  }
  return GET_POI_FOODETABLISHMENT
}

const getPoiColor = (poiType: POIType): string => {
  switch (poiType) {
    case POIType.restaurant:
      return 'orange'
    case POIType.hebergement:
      return 'purple'
    case POIType.avoir:
      return 'green'
    case POIType.afaire:
      return 'red'
    case POIType.produit:
      return 'light_green'
    case POIType.service:
      return 'blue'
    default:
      return 'red'
      break
  }
}

export { pois, generatePoiQuery, getPoiColor }
